import(/* webpackChunkName: "footerLottery" */ '../Styles/footerLottery.scss');

import "bootstrap/js/dist/collapse";

var FooterLottery = function() {
  let isProcessing = false;
  let isClickEventBind = false;

  // Click handler
  const clickHandler = function() {
    $(this).toggleClass("active");
    $(this).next().collapse("toggle");
  };

  // Window resize handler
  const reportWindowSize = function() {
    // If the previous logic is still running, there is no need to execute it again.
    if (!isProcessing) {
      isProcessing = true;

      // If it is a mobile view, create an accordion and set the necessary attributes and events.
      if ($(window).width() <= 767) {
        if (!isClickEventBind) {
          $('.footer [class*="__headline"]').each(function(index) {
            // Set click events
            $(this).on("click", clickHandler);
            // Initiated collapse
            $(this).next().collapse();
            // Wait for the collapse event to be initialized before hiding all contents.
            $(this).next().on("shown.bs.collapse", function() {
              /// Adding active class on headlline
              $(this).prev().addClass("active");
              // Removed collapse event
              $(this).off("shown.bs.collapse");
              // Collapse
              $(this).collapse("hide");
            });
          });

          isClickEventBind = true;
        }
      } else {
        if (isClickEventBind) {
          $('.footer [class*="__headline"]').each(function(index) {
            // Removed click event
            $(this).off("click");
            // Removed active class
            $(this).removeClass("active");
            // Removed all classes from sibling
            $(this).next().removeClass("collapse collapsing show");

            setTimeout(function() {
              // Dispose collapse
              $(this).next().collapse("dispose");
            }, 100);
          });

          isClickEventBind = false;
        }
      }

      isProcessing = false;
    }
  };

  const init = function() {
    // Inilized with first report of window size
    reportWindowSize();
    // Bind the report size function to the window on resize event
    window.onresize = reportWindowSize;
  };

  return {
    init: init
  };

}();

export { FooterLottery };
